import { render, staticRenderFns } from "./sidebar-filters-custom-filter-expanded.vue?vue&type=template&id=95bfb388&scoped=true&"
import script from "./sidebar-filters-custom-filter-expanded.ts?vue&type=script&lang=ts&"
export * from "./sidebar-filters-custom-filter-expanded.ts?vue&type=script&lang=ts&"
import style0 from "./sidebar-filters-custom-filter-expanded.scss?vue&type=style&index=0&id=95bfb388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bfb388",
  null
  
)

export default component.exports